if (!customElements.get('new-promotion-banner-subscription')) {
  class NewPromotionBannerSubscription extends HTMLElement {
    connectedCallback() {
      this.iconTemplate = this.querySelector('[data-subscription-arrow-template]');
      this.observer = new MutationObserver(() => this.addButtonIcon());
      this.observer.observe(this, {
        childList: true,
        subtree: true,
      });
      this.addButtonIcon();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    addButtonIcon() {
      const button = this.querySelector('.needsclick button');

      if (!button || !this.iconTemplate || button.querySelector('.new-promotion-banner__subscription-arrow')) {
        return;
      }

      const icon = this.iconTemplate.content.firstElementChild.cloneNode(true);
      button.append(icon);
    }
  }

  customElements.define('new-promotion-banner-subscription', NewPromotionBannerSubscription);
}

if (!customElements.get('new-promotion-banner-subscription-group')) {
  class NewPromotionBannerSubscriptionGroup extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('pointerdown', this.handleSubscriptionAttempt, {
        capture: true,
        signal: this.abortController.signal,
      });
    }

    disconnectedCallback() {
      this.abortController.abort();
      clearTimeout(this.warningTimeout);
    }

    handleSubscriptionAttempt = (event) => {
      const consentCheckbox = this.querySelector('[data-consent-gate-checkbox]');
      const subscribeButton = this.querySelector(
        '.new-promotion-banner__subscription .needsclick button'
      );

      if (!consentCheckbox || consentCheckbox.checked || !subscribeButton) {
        return;
      }

      if (!this.isSubscribeButtonHit(event, subscribeButton)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      this.classList.remove('is-consent-warning');
      void this.offsetWidth;
      this.classList.add('is-consent-warning');

      consentCheckbox.focus({ preventScroll: true });

      clearTimeout(this.warningTimeout);
      this.warningTimeout = setTimeout(() => {
        this.classList.remove('is-consent-warning');
      }, 480);
    };

    isSubscribeButtonHit(event, button) {
      const target = event.target instanceof Element ? event.target : null;

      if (
        target?.closest('button') === button ||
        target?.closest("[data-testid='form-component']:has(button)")
      ) {
        return true;
      }

      const rect = button.getBoundingClientRect();

      return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
    }
  }

  customElements.define('new-promotion-banner-subscription-group', NewPromotionBannerSubscriptionGroup);
}
